// Full-fidelity Truck GraphQL selection.
//
// The amplify-generated operations truncate nested objects inside
// `estimates` at their depth limit — no `lines`, no `payments`. Any code
// that reads trucks through those operations and later writes `estimates`
// back (Collections mark-paid, board actions) silently ERASES the
// truncated fields. Everything that feeds the operational store must use
// this selection instead.

const ESTIMATE_FIELDS = /* GraphQL */ `
        id
        truckId
        roNumber
        status
        lines {
          title
          complaint
          cause
          correction
          taxExempt
          laborLines {
            id
            description
            catalogItemId
            hours
            rate
            flatPrice
            amount
            techName
            notes
          }
          partLineIds
        }
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        payments {
          id
          amount
          method
          reference
          note
          receivedAt
          recordedBy
        }
        createdBy
        createdAt
        updatedAt
        version
`;

export const TRUCK_FIELDS = /* GraphQL */ `
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
      }
      laborType
      customerType
      poNumber
      shopId
      customerId
      unitId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
      }
      estimates {
${ESTIMATE_FIELDS}
      }
      createdAt
      updatedAt
`;

export const listTrucksFull = /* GraphQL */ `
  query ListTrucksFull(
    $filter: ModelTruckFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrucks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
${TRUCK_FIELDS}
      }
      nextToken
    }
  }
`;

export const onCreateTruckFull = /* GraphQL */ `
  subscription OnCreateTruckFull {
    onCreateTruck {
${TRUCK_FIELDS}
    }
  }
`;

export const onUpdateTruckFull = /* GraphQL */ `
  subscription OnUpdateTruckFull {
    onUpdateTruck {
${TRUCK_FIELDS}
    }
  }
`;

export const onDeleteTruckLite = /* GraphQL */ `
  subscription OnDeleteTruckLite {
    onDeleteTruck {
      id
    }
  }
`;
